import { render, staticRenderFns } from "./Milestone.vue?vue&type=template&id=1d2d8012"
import script from "./Milestone.vue?vue&type=script&lang=js"
export * from "./Milestone.vue?vue&type=script&lang=js"
import style0 from "./Milestone.vue?vue&type=style&index=0&id=1d2d8012&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports